/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-cond-assign */
import { onReady } from "/Assets/js/utilities.js";
import { Bouncer } from "/Assets/libs/bouncer-es6.js";

export default class Shipbilding {
    constructor() { }

    init() {
        onReady(() => {
            this.$element = $(".shipbuilding-cost-calculator");
            if (!this.$element.length)
                return;

            this.bindEvents();
            this.setupFormValidation();
        });
    }

    bindEvents() {
        const self = this;

        document.addEventListener("bouncerFormValid", function (event) {
            if (event.target.classList.contains("shipbuilding-cost-calculator-form")) {
                var rawEmployees = self.getEmployeesRawValue();
                rawEmployees = rawEmployees.replace(/,/g, "");
                self.employees = parseInt(rawEmployees);
                self.laborRate = parseInt(self.getHourlyRawValue());

                self.calculateCostSavings();
                self.$element
                    .find(".results")
                    .show()
                    .scrollIntoView(120);
            }
        }, false);

        self.$element.find(".close-sbcalculator").on("click", function (e) {
            e.preventDefault();
            self.$element.find(".results").hide();
        });
    }

    setupFormValidation() {
        const self = this;
        let bouncer = new Bouncer("[data-validate]", {
            disableSubmit: true,
            messages: {
                missingValue: {
                    default: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired
                },
                patternMismatch: {
                    number: window.jsl10n.JsResources.Translations.Common.EnterValidNumber,
                    default: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired
                }
            }
        });
        self.bouncer = bouncer;
    }

    getEmployeesRawValue() {
        var employeesValue = $("#number-of-employees").val();
        return employeesValue;
    }

    getHourlyRawValue() {
        var hourlyValue = $("#hourly-labor-rate").val();
        var hourlyRawValue = hourlyValue.replace(/\$/g, "");
        return hourlyRawValue;
    }

    calculateCostSavings() {
        var burner = 0.05975;
        var tempPerc = 0.17;
        var skelPerc = 0.15;
        var genCutPerc = 0.4;
        var postPerc = 0.2;
        var gougePerc = 0.5;

        var dailyTorch = 0.15;
        var opDays = 312;
        var inchProc = 775;

        var plasCutSpeed = 56;
        var plasFlushCutSpeed = 90;
        var plasGrindSpeed = 60;
        var plasSetup = 0.125;
        var plasGougeSpeed = 20;

        var altCutSpeed = 20;
        var altGrindSpeed = 24;
        var altSetup = 0.4375;
        var altPreheat = 0.14583;
        var altGougeSpeed = 10;

        var burners = burner * this.employees;

        var tempInches = burners * tempPerc * (dailyTorch * opDays * inchProc);
        var skelInches = burners * skelPerc * (dailyTorch * opDays * inchProc);
        var genInches = burners * genCutPerc * (dailyTorch * opDays * inchProc);
        var postInches = burners * postPerc * (dailyTorch * opDays * inchProc);
        var gougeInches = burners * gougePerc * (dailyTorch * opDays * inchProc);

        var plasmaSetup = burners * plasSetup * (dailyTorch * opDays);
        var alterSetup = burners * altSetup * (dailyTorch * opDays);
        var alterPreheat = burners * altPreheat * (dailyTorch * opDays);

        var altTempTime =
            tempInches / 60 * (1 / altCutSpeed + 1 / altGrindSpeed) + (alterSetup + alterPreheat);
        var altSkelTime = skelInches / 60 * (1 / altCutSpeed) + (alterSetup + alterPreheat);
        var altGenTime =
            genInches / 60 * (1 / altCutSpeed + 1 / altGrindSpeed) + (alterSetup + alterPreheat);
        var altPostTime =
            postInches / 60 * (1 / altCutSpeed + 1 / altGrindSpeed) + (alterSetup + alterPreheat);

        var altGougeGrind = gougeInches * (20 / 60 / 1200); //gouge length x 20 mins per 100 ft
        var altGougeTime = gougeInches / altGougeSpeed / 60 + altGougeGrind; //gouge length x CAG speed x employees x opdays + CAG grinding time

        var plasmaTempTime =
            tempInches / 60 * (1 / plasFlushCutSpeed + 1 / plasGrindSpeed) + plasmaSetup;
        var plasmaSkelTime = skelInches / 60 * (1 / plasCutSpeed) + plasmaSetup;
        var plasmaGenTime = genInches / 60 * (1 / plasCutSpeed + 1 / plasGrindSpeed) + plasmaSetup;
        var plasmaPostTime =
            postInches / 60 * (1 / plasCutSpeed + 1 / plasGrindSpeed) + plasmaSetup;
        var plasmaGougeTime = gougeInches / 60 / plasGougeSpeed + altGougeGrind * 0.5; //gouge length in hours / gouge speed + 50% of CAG grinding time

        var tempTimeSave = altTempTime - plasmaTempTime;
        var skelTimeSave = altSkelTime - plasmaSkelTime;
        var genTimeSave = altGenTime - plasmaGenTime;
        var postTimeSave = altPostTime - plasmaPostTime;
        var gougeTimeSave = altGougeTime - plasmaGougeTime;

        var tempTS = Math.round(tempTimeSave).toLocaleString();
        var skelTS = Math.round(skelTimeSave).toLocaleString();
        var genTS = Math.round(genTimeSave).toLocaleString();
        var postTS = Math.round(postTimeSave).toLocaleString();
        var gougeTS = Math.round(gougeTimeSave).toLocaleString();

        var tempPI = (tempTimeSave / altTempTime).toLocaleString(undefined, {
            style: "percent",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        var skelPI = (skelTimeSave / altSkelTime).toLocaleString(undefined, {
            style: "percent",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        var genPI = (genTimeSave / altGenTime).toLocaleString(undefined, {
            style: "percent",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        var postPI = (postTimeSave / altPostTime).toLocaleString(undefined, {
            style: "percent",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        var gougePI = (gougeTimeSave / altGougeTime).toLocaleString(undefined, {
            style: "percent",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });

        var tempCS = Math.round(tempTimeSave * this.laborRate).toLocaleString();
        var skelCS = Math.round(skelTimeSave * this.laborRate).toLocaleString();
        var genCS = Math.round(genTimeSave * this.laborRate).toLocaleString();
        var postCS = Math.round(postTimeSave * this.laborRate).toLocaleString();

        var gougeCS = Math.round(gougeTimeSave * this.laborRate).toLocaleString(); //labor + parts + air + grinding costs (PMX grind time is 1/2 of CAG grind time)

        this.$element.find("[data-skeleton-removal-hours]").text(skelTS);
        this.$element.find("[data-skeleton-removal-percent]").text(skelPI);
        this.$element.find("[data-skeleton-removal-savings]").text("$" + skelCS);

        this.$element.find("[data-beveling-hours]").text(postTS);
        this.$element.find("[data-beveling-percent]").text(postPI);
        this.$element.find("[data-beveling-savings]").text("$" + postCS);

        this.$element.find("[data-temp-attachments-hours]").text(tempTS);
        this.$element.find("[data-temp-attachments-percent]").text(tempPI);
        this.$element.find("[data-temp-attachments-savings]").text("$" + tempCS);

        this.$element.find("[data-general-cutting-hours]").text(genTS);
        this.$element.find("[data-general-cutting-percent]").text(genPI);
        this.$element.find("[data-general-cutting-savings]").text("$" + genCS);

        this.$element.find("[data-gouging-hours]").text(gougeTS);
        this.$element.find("[data-gouging-percent]").text(gougePI);
        this.$element.find("[data-gouging-savings]").text("$" + gougeCS);
    }
}
